import React from 'react';
import { HomeHeader } from '../components/home/HomeHeader';
import { HomeBanner } from '../components/home/HomeBanner';
import { QuickEntries } from '../components/home/QuickEntries';
import { RecommendSections } from '../components/home/RecommendSections';
import { PlatformFooterBar } from '../components/home/PlatformFooterBar';
export function Home() {
  return <div className="bg-slate-50 min-h-screen pb-32" data-id="element-452">
      <HomeHeader data-id="element-453" />
      <HomeBanner data-id="element-454" />
      <QuickEntries data-id="element-455" />
      <RecommendSections data-id="element-456" />
      <PlatformFooterBar data-id="element-457" />
    </div>;
}